// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"a2402db5","398":"aed5548d","736":"87202079","886":"b905db92"}[chunkId] + ".chunk.css";
};